export const DefaultListProps = {
    focusedIndex: null,
    link: true
};
export const DefaultHashHintProps = {
    filter: null,
    filterReset: true,
    focusedIndex: 0,
    maxWidth: '400px',
    minWidth: '200px'
};
//# sourceMappingURL=constants.js.map